import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Container,
  LinearProgress,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { styled } from '@mui/material/styles';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
// import echobuddyLogo from "../../assets/echobuddy.png";
import echobuddyLogo from "../../assets/newEchoLogo.png";
import { submitSubjectiveWellbeingAssessment} from "../../service/subjectiveWellbeing";


const options = [
  "Strongly Disagree",
  "Moderately Disagree",
  "Slightly Disagree",
  "Slightly Agree",
  "Moderately Agree",
  "Strongly Agree"
];

const questions = [
  {
    id: 1,
    reverse: true,
    question: 'I don\'t feel particularly pleased with my current work assignment',
    
  },
  {
    id: 2,
    reverse: false,
    question: 'I am interested in interacting with other people',
   
  },
  {
    id: 3,
    reverse: false,
    question: 'I feel that life is very rewarding',
    
  },
  {
    id: 4,
    reverse: false,
    question: 'I have very warm feelings towards almost everyone',
  
  },
  {
    id: 5,
    reverse: true,
    question: 'I rarely wake up feeling rested',
    
  },
  {
    id: 6,
     reverse: true,
    question: 'I am not particularly optimistic about my career growth',
   
  },
  {
    id: 7,
     reverse: false,
    question: 'I find most things amusing',
   
  },
  {
    id: 8,
      reverse: false,
    question: 'I am always committed and involved',
  
  },
  {
    id: 9,
      reverse: false,
    question: 'Life is good',
   
  },
  {
    id: 10,
      reverse: false,
    question: 'I don\'t think that the world is a good place',
    
  
  },
  {
    id: 11,
      reverse: false,
    question: 'I laugh a lot',
   
  },
  {
    id: 12,
      reverse: false,
    question: 'I am well satisfied about everything in my life',
  
  },
  {
    id: 13,
      reverse: true,
    question: 'I don\'t think I look attractive',
   
  },
  {
    id: 14,
      reverse: true,
    question: 'There is a gap between what I would like to do and what I am doing',
   
  },
  {
    id: 15,
      reverse: false,
    question: 'I am very happy',
   
  },
  {
    id: 16,
      reverse: false,
    question: 'I find beauty in some things',
   
  },
  {
    id: 17,
      reverse: false,
    question: 'I always have a cheerful effect on others',
    
  },
  {
    id: 18,
      reverse: false,
    question: 'I can fit in everything I want to',
   
  },
  {
    id: 19,
      reverse: true,
    question: 'I feel that I am not especially in control of my life',
   
  },
  {
    id: 20,
      reverse: false,
    question: 'I feel able to take any work allocated to me',
   
  },
  {
    id: 21,
      reverse: false,
    question: 'I feel fully mentally alert',
    
  },
  {
    id: 22,
      reverse: false,
    question: 'I often experience joy and elation',
   
  },
  {
    id: 23,
      reverse: true,
    question: 'I do not find it easy to make decisions',
   
  },
  {
    id: 24,
      reverse: true,
    question: 'I do not have a particular sense of meaning and purpose in my life',
    
  },
  {
    id: 25,
      reverse: false,
    question: 'I feel I have a great deal of energy',
   
  },
  {
    id: 26,
      reverse: false,
    question: 'I usually have a good influence on events',
  
  },
  {
    id: 27,
      reverse: true,
    question: 'I do not enjoy when other people are around',
    
  },
  {
    id: 28,
      reverse: true,
    question: 'I don\'t feel I get sufficient sleep',
    
  },
  {
    id: 29,
      reverse: true,  
    question: 'I do not have particularly happy memories of the past',
   
  }
];

const wellbeingMessages = {
  excellent: {
    title: "Excellent",
    immediate: [
      "Congratulations! Your mental well-being score is awesome.",
      "Your mental well-being is in a really good place right now! That's great!",
      "You are doing a wonderful job taking care of your mental well-being.",
      "Awesome! This reflects a healthy and balanced state. Keep going!"
    ],
    followUp: [
      "Keep supporting this by doing what already works for you — you can also explore echo soundscapes to maintain this balance.",
      "Consistency is key here — small, regular resets like our soundscapes can help you sustain this.",
      "You’re on the right track — continue with habits that support you, and explore echo soundscapes to stay there.",
      "Maintaining this state matters — simple tools like guided soundscapes can help you keep this steady."
    ]
  },

  good: {
    title: "Good",
    immediate: [
      "Well done! You are taking good care of your mental well-being and it's worth acknowledging!",
      "You seem to be in a positive space mentally. That's a great place to be.",
      "You’re in a good space mentally — good efforts!",
      "Things seem to be going well for you, with room to strengthen further."
    ],
    followUp: [
      "A few small shifts can make this even better — try using echo soundscapes to recharge when needed.",
      "You’re doing well — adding small pauses or resets through soundscapes can help you feel even better.",
      "You’re on a good path — explore echo soundscapes to build more consistency in how you feel.",
      "This is a good foundation — simple tools like guided soundscapes can help you strengthen it further."
    ]
  },

  moderate: {
    title: "Moderate",
    immediate: [
      "There’s some room here to improve how you’re feeling day-to-day.",
      "You may be experiencing a few ups and downs — that’s okay, and it’s something you can work on.",
      "Things might feel a bit uneven right now — and that’s worth paying attention to.",
      "You’re managing, but there’s scope to feel better with a few changes."
    ],
    followUp: [
      "Small steps can make a difference — try taking short breaks, getting some fresh air, or exploring echo soundscapes.",
      "Start with simple resets — a short walk, a pause, or guided soundscapes can help shift how you feel.",
      "You don’t need big changes — even small moments of pause or using soundscapes can help improve your state.",
      "Try introducing small recovery moments in your day — soundscapes or mindful pauses can be a good start."
    ]
  },

  low: {
    title: "Low",
    immediate: [
      "It seems like things may be feeling difficult right now. Would you like to talk about it?",
      "You may be going through a challenging phase, but support is available. Reach out to us if you'd like to talk.",
      "It looks like you may be having a tough time — it’s important to take this seriously.",
      "Things might feel heavy or overwhelming right now and that’s okay to acknowledge. Do reach out if you'd like to talk."
    ],
    followUp: [
      "You don’t have to navigate this alone — consider reaching out to a counsellor or exploring echo soundscapes for support.",
      "Talking to someone can really help — you can connect with a counsellor or start with calming soundscapes.",
      "Support can make a difference here — consider speaking to a counsellor or using soundscapes to ease your mind.",
      "Take this one step at a time — reaching out for support or using guided soundscapes can help you begin."
    ]
  }
};

const getWellbeingContent = (score) => {

  let category;

  if (score >= 138) {
    category = wellbeingMessages.excellent;
  } else if (score >= 102) {
    category = wellbeingMessages.good;
  } else if (score >= 66) {
    category = wellbeingMessages.moderate;
  } else {
    category = wellbeingMessages.low;
  }

  const immediateMessage =
    category.immediate[
      Math.floor(Math.random() * category.immediate.length)
    ];

  const followUpMessage =
    category.followUp[
      Math.floor(Math.random() * category.followUp.length)
    ];

  return {
    title: category.title,
    immediateMessage,
    followUpMessage
  };
};

const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: 16,
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
  border: '1px solid #e0e0e0',
  '&:hover': {
    boxShadow: '0 6px 24px rgba(0, 0, 0, 0.12)'
  }
}));

const OptionButton = styled(FormControlLabel)(({ theme, checked }) => ({
  margin: '8px 0',
  padding: '12px 16px',
  borderRadius: 12,
  border: checked ? '2px solid #4a6cf7' : '1px solid #e0e0e0',
  backgroundColor: checked ? 'rgba(74, 108, 247, 0.05)' : 'white',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: 'rgba(74, 108, 247, 0.05)',
    borderColor: '#4a6cf7'
  },
  '& .MuiFormControlLabel-label': {
    width: '100%',
    marginLeft: 12
  }
}));

const HealthSurvey = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [currentQuestion, setCurrentQuestion] = useState(-1); // Start with -1 to show welcome screen
  const [answers, setAnswers] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showWelcome, setShowWelcome] = useState(true);

const [resultContent, setResultContent] = useState(null);

const renderFollowUpMessage = (message) => {
  return message.split(/(echo soundscapes|soundscapes)/gi).map((part, index) => {
    const normalized = part.toLowerCase();

    if (
      normalized === "echo soundscapes" ||
      normalized === "soundscapes"
    ) {
      return (
        <Typography
          component="span"
          key={index}
          onClick={() => navigate('/echo-sounds')}
          sx={{
            color: '#14b8a6',
            fontWeight: 700,
            cursor: 'pointer',
            textDecoration: 'underline',
            '&:hover': {
              color: '#0f766e'
            }
          }}
        >
          Echo Soundscapes
        </Typography>
      );
    }

    return part;
  });
};

const handleOptionSelect = (
  questionId,
  option
) => {

  setAnswers({
    ...answers,
    [questionId]: option
  });
};

  const handleNext = () => {
    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    }
  };

  const handlePrevious = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(currentQuestion - 1);
    }
  };

const handleSubmit = async () => {

  const questionScores = {};

  Object.entries(answers).forEach(
    ([questionId, answer]) => {

      const question = questions.find(
        (q) => q.id === Number(questionId)
      );

      const optionIndex =
        options.indexOf(answer);

      let score;

      if (question.reverse) {
        score = 6 - optionIndex;
      } else {
        score = optionIndex + 1;
      }

      questionScores[questionId] = score;
    }
  );

const user = JSON.parse(
  localStorage.getItem("user") || "{}"
);

console.log("Logged in user:", user);

const assessmentData = {
  user_id: user.id,
  question_scores: questionScores
};

console.log("Assessment payload:", assessmentData);

  console.log(assessmentData);

  const response =
    await submitSubjectiveWellbeingAssessment(
      assessmentData
    );

  if (!response) {
    alert("Failed to submit assessment");
    return;
  }

  const content =
    getWellbeingContent(totalScore);

  setResultContent(content);

  setIsSubmitted(true);
};
const totalScore = Object.entries(answers).reduce(
  (total, [questionId, answer]) => {

    const question = questions.find(
      (q) => q.id === Number(questionId)
    );

    const optionIndex = options.indexOf(answer);

    let score;

    if (question.reverse) {
      score = 6 - optionIndex;
    } else {
      score = optionIndex + 1;
    }

    return total + score;

  },
  0
);

  
  if (showWelcome) {
    return (
      <Box sx={{ minHeight: '100vh', bgcolor: '#f8f9ff', pt: 4, position: 'relative' }}>
        {/* Logo positioned at top-left */}

        {/* <Box
          sx={{
            position: 'absolute',
            top: { xs: 18, sm: 18, md: 24 },
            left: { xs: 16, sm: 24, md: 32 },
            zIndex: 1000,
            display: 'flex',
            alignItems: 'flex-start',
            gap: 0.75,
          }}
        > */}
        {/* <Link to="/home" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '0.75rem' }}> */}
        {/* Logo */}
        {/* <img
              src={echobuddyLogo}
              alt="EchoBuddy"
              style={{
                height: 45,
                width: 45,
                borderRadius: '50%',
                objectFit: 'cover',
                marginTop: '0.1rem',
              }}
            /> */}

        {/* Text */}
        {/* <Box> */}
        {/* <Typography
                sx={{
                  fontSize: '1.4rem',
                  fontWeight: 700,
                  letterSpacing: '0.5px',
                  color: "#7843f3",
                  lineHeight: 1.1,
                  mb: 0.2,
                }}
              >
                echoBuddy
              </Typography> */}

        {/* <Typography
                variant="caption"
                sx={{
                  color: "#7843f3",
                  fontSize: '0.65rem',
                  fontWeight: 500,
                  letterSpacing: '0.3px',
                  display: 'block',
                  lineHeight: 1.2,
                }}
              >
                Connect. Heal. Rise.
              </Typography> */}
        {/* </Box> */}
        {/* </Link> */}
        {/* </Box> */}

        <Box sx={{
          position: 'absolute',
          right: { xs: 16, sm: 24, md: 32 },
          top: { xs: 16, sm: 24, md: 32 },
          zIndex: 1000
        }}>
          <Button
            onClick={() => navigate(-1)}
            startIcon={<ArrowBackIosIcon sx={{ fontSize: 14 }} />}
            sx={{
              color: "#7843f3",
              textTransform: 'none',
              fontWeight: 500,
              '&:hover': {
                backgroundColor: 'rgba(74, 108, 247, 0.05)'
              }
            }}
          >
            Back
          </Button>
        </Box>
        <Container maxWidth="md" sx={{ mt: 4 }}>

          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Typography variant="h6" sx={{ background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text', fontWeight: 600 }}>
              Subjective Well-being Assessment
            </Typography>
          </Box>

          <StyledCard
  sx={{
    borderRadius: '28px',
    border: '1px solid rgba(255,255,255,0.7)',
    backdropFilter: 'blur(10px)',
    boxShadow: '0 20px 60px rgba(99, 102, 241, 0.12)',
    position: 'relative',
    zIndex: 2
  }}
>
            <CardContent sx={{ p: isMobile ? 3 : 5, textAlign: 'left' }}>
              <Typography variant="body1" paragraph sx={{ mb: 3, lineHeight: 1.8, color: '#495057' }}>
                {/* Welcome to echo Subjective Well-being (echo SWB) self-assessment scale. echo SWB is tailor made for organisations employees based on an international scale. It helps you reflect on your well-being that is personal to you. */}
                Welcome to echo Subjective Well-being (echo SWB) Self-Assessment scale. echo SWB is tailor made for employees in organisations benchmarked against international scale. It helps you reflect on your personal well-being.
              </Typography>

              <Typography variant="body1" paragraph sx={{ mb: 3, lineHeight: 1.8, color: '#495057' }}>
                There are 29 questions related broadly to your life experiences. It would take approximately about 10 - 15 minutes to complete the assessment. All the questions are required for a complete assessment.
              </Typography>

              <Typography variant="body1" paragraph sx={{ mb: 3, lineHeight: 1.8, color: '#495057' }}>
                There are no right or wrong answers. Choose the option that most likely your answer. There is no time limit but do not take too long to answer to be your natural choice.
              </Typography>

              <Typography variant="body1" paragraph sx={{ mb: 4, lineHeight: 1.8, color: '#495057' }}>
                The results are for your self-discovery and so it is available only to you.
              </Typography>

              <Typography variant="h6" sx={{ textAlign: 'center', mb: 3, background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
                Good luck and start your assessment
              </Typography>

              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                <Button
                  variant="contained"
                  size="large"
                  onClick={() => {
                    setShowWelcome(false);
                    setCurrentQuestion(0);
                  }}
                  sx={{
                    background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                    color: 'white',
                    px: 4,
                    py: 1.5,
                    borderRadius: 2,
                    textTransform: 'none',
                    fontSize: '1.1rem',
                    fontWeight: 500,
                    '&:hover': {
                      backgroundColor: '#3a5bd9',
                    },
                    boxShadow: '0 4px 12px rgba(74, 108, 247, 0.3)'
                  }}
                >
                  Start Assessment
                </Button>
              </Box>
            </CardContent>
          </StyledCard>
        </Container>
      </Box >
    );
  }

  // Show completion screen
  if (isSubmitted) {
    return (
      <Box sx={{ minHeight: '100vh', bgcolor: '#f8f9ff', pt: 4, position: 'relative' }}>
        {/* Logo positioned at top-left */}
       

        <Container maxWidth="sm">
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <img src={echobuddyLogo} alt="echobuddyLogo" style={{ height: 40, marginBottom: 16 }} />
<Typography
  sx={{
    fontSize: {
      xs: '1.5rem',
      sm: '2rem'
    },
    fontWeight: 700,
    textAlign: 'center',
    background:
      'linear-gradient(135deg, #22c55e, #14b8a6, #6366f1)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    mb: 1,
    lineHeight: 1.3
  }}
>
  Echo Subjective Well-Being Self-Assessment
</Typography>    
<Box
  sx={{
    width: 120,
    height: 4,
    borderRadius: 10,
    mx: 'auto',
    mb: 4,
    background:
      'linear-gradient(90deg, #22c55e, #6366f1)'
  }}
/>
      </Box>
          <StyledCard>
          <CardContent sx={{ p: isMobile ? 2.5 : 4, textAlign: 'center' }}>

  {/* Score Badge */}
 <Box
  sx={{
    background:
      'linear-gradient(135deg, #22c55e 0%, #14b8a6 50%, #8b5cf6 100%)',
    p: 2,   
     borderRadius: '18px',
    color: '#fff',
    textAlign: 'center',
    mb: 3,
    position: 'relative',
    overflow: 'hidden',
  }}
>
  <Box
    sx={{
      position: 'absolute',
      width: 120,
      height: 120,
      borderRadius: '50%',
      background: 'rgba(255,255,255,0.08)',
      top: -30,
      right: -20,
    }}
  />

  <Typography
    sx={{
      fontSize: '2.2rem',
      fontWeight: 900,
      lineHeight: 1,
    }}
  >
    {totalScore}
  </Typography>

  <Typography
    sx={{
      opacity: 0.9,
      fontSize: '0.95rem',
      mt: 0.5,
    }}
  >
    out of 174
  </Typography>

  <Typography
    sx={{
      fontSize: '1.05rem',
      mt: 1
    }}
  >
    Your Well-being is {resultContent?.title}
  </Typography>
</Box>

  {/* Immediate Message */}
 <Box
  sx={{
    p: 1.5,
    borderRadius: '14px',
    mb: 1.5,
    background: '#fff',
    border: '1px solid #e2e8f0',
    boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
    
  }}
>
  <Typography
    sx={{
      color: '#000000',
      fontSize: '0.82rem',
      lineHeight: 1.6,
      textAlign: 'center',
    }}
  >
    {resultContent?.immediateMessage}
  </Typography>
</Box>

  {/* Follow Up Box */}
 <Box
  sx={{
    background:
      'linear-gradient(135deg, rgba(34,197,94,0.08), rgba(99,102,241,0.08))',
    border: '1px solid rgba(34,197,94,0.15)',
    p: 1.8,
    borderRadius: '14px',
    mb: 2,
  }}
>
  <Typography
    sx={{
      fontWeight: 700,
      color: '#0f766e',
      mb: 1,
      display: 'flex',
      alignItems: 'center',
      gap: 1,
    }}
  >
    ✨ Recommended Next Step
  </Typography>

  <Typography
    sx={{
      color: '#000000',
      lineHeight: 1.8,
      fontSize: '0.92rem',
    }}
  >
    {renderFollowUpMessage(
  resultContent?.followUpMessage
)}
  </Typography>
</Box>


  {/* CTA Button */}
<Button
  variant="contained"
  onClick={() => navigate('/home')}
  sx={{
    background:
      'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
    px: 3,
py: 0.9,
    fontWeight: 700,
    fontSize: '0.9rem',
    borderRadius: '12px',
    textTransform: 'none',
    boxShadow: '0 8px 24px rgba(99,102,241,0.25)',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 12px 30px rgba(99,102,241,0.35)',
    },
    transition: 'all 0.25s ease',
  }}
>
  Back to Home
</Button>

</CardContent>
          </StyledCard>
        </Container>
      </Box>
    );
  }

  const currentQ = questions[currentQuestion];
  const progress = ((currentQuestion + 1) / questions.length) * 100;



  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f8f9ff', pt: 4, position: 'relative' }}>
      {/* Logo positioned at top-left */}

      {/* <Box sx={{
        position: 'absolute',
        top: { xs: 18, sm: 18, md: 24 },
        left: { xs: 16, sm: 24, md: 32 },
        zIndex: 1000,
        display: 'flex',
        alignItems: 'flex-start',
        gap: 0.75
      }}> */}
      {/* <Link to="/home" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '0.75rem' }}> */}
      {/* Logo */}
      {/* <img
            src={echobuddyLogo}
            alt="Echo"
            style={{
              height: 45,
              width: 45,
              borderRadius: '50%',
              objectFit: 'cover',
              marginTop: "0.1rem"
            }}
          /> */}
      {/* Text */}
      {/* <Box>
            <Typography sx={{
              fontSize: '1.4rem',
              fontWeight: 700,
              letterSpacing: '0.5px',
              color: "#7843f3",
              lineHeight: 1.1,
              mb: 0.2
            }}> */}
      {/* echoBuddy
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: "#7843f3",
                fontSize: '0.65rem',
                fontWeight: 500,
                letterSpacing: '0.3px',
                display: 'block',
                lineHeight: 1.2
              }}
            > */}
      {/* Connect. Heal. Rise.
            </Typography>
          </Box> */}
      {/* </Link> */}
      {/* </Box> */}

      <Container maxWidth="sm">
        {/* Header with Back Button */}
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 4, px: isMobile ? 2 : 0, pt: { xs: 6, sm: 4, md: 2 } }}>
          <Box sx={{ flex: 1, textAlign: 'center' }}>
            <Typography variant="h6" sx={{ background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text', fontWeight: 600, }}>
              Subjective Well-Being Self-Assessment
            </Typography>
          </Box>
          <Box sx={{ width: 80 }} /> {/* For balance */}
        </Box>

        {/* Progress Bar */}
        <Box sx={{ mb: 3, px: isMobile ? 2 : 0 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
            <Typography variant="caption" sx={{ color: '#4a6cf7', fontWeight: 500 }}>
              Question {currentQuestion + 1} of {questions.length}
            </Typography>
            <Typography variant="caption" sx={{ color: '#6b7c93' }}>
              {Math.round(progress)}% Complete
            </Typography>
          </Box>
          <LinearProgress
            variant="determinate"
            value={progress}
            sx={{
              height: 8,
              borderRadius: 4,
              backgroundColor: '#e9ecef',
              '& .MuiLinearProgress-bar': {
                borderRadius: 4,
                background: 'linear-gradient(90deg, #4a6cf7 0%, #2541b2 100%)'
              }
            }}
          />
        </Box>

        {/* Question Card */}
        <StyledCard>
          <CardContent sx={{ p: isMobile ? 3 : 4 }}>
            <Typography
              variant="h6"
              sx={{
                color: '#103680',
                fontWeight: 500,
                mb: 3,
                fontSize: isMobile ? '1.1rem' : '1.25rem',
                lineHeight: 1.4
              }}
            >
              {currentQ.question}
            </Typography>

            <FormControl component="fieldset" sx={{ width: '100%' }}>
              <RadioGroup
                aria-label="survey"
                name="survey-questions"
                value={answers[currentQ.id] || ''}
                
              >
                {options.map((option, index) => (
                  <OptionButton
                    key={index}
                    value={option}
                    control={
                      <Radio
                        sx={{
                          color: '#4a6cf7',
                          '&.Mui-checked': {
                            color: '#4a6cf7',
                          },
                        }}
                      />
                    }
                    label={
                      <Typography sx={{
                        color: answers[currentQ.id] === option ? '#103680' : '#495057',
                        fontWeight: answers[currentQ.id] === option ? 600 : 400,
                        fontSize: isMobile ? '0.95rem' : '1rem'
                      }}>
                        {option}
                      </Typography>
                    }
                   checked={
                      answers[currentQ.id] === option
                    }
                  onChange={() =>
                    handleOptionSelect(
                      currentQ.id,
                      option
                    )
                  }
                  />
                  
                ))}
              </RadioGroup>
            </FormControl>

            <Box sx={{
              display: 'flex',
              justifyContent: 'space-between',
              mt: 4,
              pt: 2,
              borderTop: '1px solid #f1f3f9'
            }}>
              <Button
                onClick={handlePrevious}
                disabled={currentQuestion === 0}
                variant="outlined"
                sx={{
                  px: 4,
                  py: 1.5,
                  borderRadius: 3,
                  textTransform: 'none',
                  fontWeight: 600,
                  color: '#4a6cf7',
                  borderColor: '#4a6cf7',
                  '&:hover': {
                    backgroundColor: 'rgba(74, 108, 247, 0.05)',
                    borderColor: '#4a6cf7'
                  }
                }}
              >
                Previous
              </Button>

              {currentQuestion === questions.length - 1 ? (
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  disabled={!answers[currentQ.id]}
                  sx={{
                    px: 4,
                    py: 1.5,
                    borderRadius: 3,
                    textTransform: 'none',
                    fontWeight: 600,
                    background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)'
                    ,
                    '&:hover': {
                      boxShadow: '0 6px 20px rgba(74, 108, 247, 0.4)'
                    },
                    '&.Mui-disabled': {
                      background: '#e9ecef',
                      color: '#adb5bd'
                    }
                  }}
                >
                  Submit Survey
                </Button>
              ) : (
                <Button
                  onClick={handleNext}
                  variant="contained"
                  disabled={!answers[currentQ.id]}
                  sx={{
                    px: 4,
                    py: 1.5,
                    borderRadius: 3,
                    textTransform: 'none',
                    fontWeight: 600,
                    background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                    '&:hover': {
                      boxShadow: '0 6px 20px rgba(74, 108, 247, 0.4)'
                    },
                    '&.Mui-disabled': {
                      background: '#e9ecef',
                      color: '#adb5bd'
                    }
                  }}
                >
                  Next
                </Button>
              )}
            </Box>
          </CardContent>
        </StyledCard>
      </Container>
    </Box>
  );
};

export default HealthSurvey;
